import { UserRole } from '@repo/shared-types';

export const ROLES = {
  ADMIN: UserRole.ADMIN,
  PLATFORM_ADMIN: UserRole.PLATFORM_ADMIN,
  PM: UserRole.PROPERTY_MANAGER,
  TENANT: UserRole.TENANT,
  OWNER: UserRole.OWNER,
  VENDOR: UserRole.VENDOR,
  INVESTOR: UserRole.INVESTOR,
  SYSTEM_ADMIN: UserRole.SYSTEM_ADMIN,
};

/** Back-office / PM console access: platform operators + firm staff (org scope enforced in API RLS for PM). */
export const MANAGEMENT_ROLES = [ROLES.ADMIN, ROLES.PLATFORM_ADMIN, ROLES.SYSTEM_ADMIN, ROLES.PM];
export const FINANCIAL_ROLES = [ROLES.ADMIN, ROLES.PLATFORM_ADMIN, ROLES.SYSTEM_ADMIN, ROLES.PM];
export const PORTAL_ROLES = [ROLES.TENANT, ROLES.OWNER, ROLES.VENDOR, ROLES.INVESTOR];
